import { combineReducers } from 'redux';
import draftReducer from './draft-reducer';
import actionTypes from './action-types';
import tclocal from '../ter/ter-consts-local-lib';
import { routeDataGet } from '../utils/routes-helper';
import counter from '../utils/counter-utils';

// ROOT REDUCER

const initialState = {
  initialized_all: false,
  initialized_0_virtel_schema_optimized: false,
  initialized_1_settings: false,
  initialized_1_1_users_cache: false,
  initialized_1_2_lib_ter_const: false,
  initialized_1_3_lib_virtel_params: false,
  initialized_1_4_lib_materijal_lim: false,
  initialized_1_5_lib_cnc_s4_template: false,
  initialized_1_6_lib_document: false,
  initialized_1_7_lib_cparams: false,
  initialized_2: false, // TODO
  cheats: {
    enabled: false
  },
  global_freshness: 0,
  routeSimple: {
    route: 'HOME',
    title: 'Početna',
    breadcrumbs: [],
    route_params: {},
    freshness: 0
  },
  user: {
    ulogovan: false,
    role: 'GUEST',
    id: null,
    username: '',
  },
  serverInfo: 'UNKNOWN',
  authLoginFetching: false,
  authInitialAutologinCompleted: false,
  toastTitle: '',
  toastClosing: false,
  toasts: [],
  modal: {
    modalContent: false,
    animateOut: false
  },
  secondScreen: {
    opened: false,
    back_to_route: 'HOME'
  },
  spinnerGlobal: false,
  opstiPodaci: {
    fetching: false
  },
  nesto: {
    data: []
  },
  clickedModulSubkey: null,
  clickedKomoraSubkey: null,
  userList: {
    fetching: false,
    data: []
  },
  comorderList: {
    fetching: false,
    data: []
  },
  comorderCurrent: false,
  comorditemCreatedEntityId: false,
  comorditemList: {
    fetching: false,
    data: []
  },
  comorditemCurrent: false,
  externalFiles: {
    fetching: false,
    data: {}
  },
  ppGenusList: {
    fetching: false,
    data: []
  },
  obavestenja: [],
  specialPromises: [],
  _dev_db_whole: null,
  cb_inbox_freshness: 0,
  z3d: {
    modal_opened: false,
    cb: null
  }
}

const appReducer = (state = initialState, action) => {

  switch (action.type) {

    case actionTypes.INITIALIZED_ALL:
      return {
        ...state,
        initialized_all: true
      };

    case actionTypes.INITIALIZED_INITIAL_SETTINGS:
      return {
        ...state,
        initialized_1_settings: true
      };
    case actionTypes.INITIALIZED_VIRTEL_SCHEMA_OPTIMIZED:
      return {
        ...state,
        initialized_0_virtel_schema_optimized: true
      };

    case actionTypes.INITIALIZED_LIB_VIRTEL_PARAMS:
      return {
        ...state,
        initialized_1_3_lib_virtel_params: true
      };
    case actionTypes.INITIALIZED_LIB_MATERIJAL_LIM:
      return {
        ...state,
        initialized_1_4_lib_materijal_lim: true
      };
    case actionTypes.INITIALIZED_LIB_CNC_S4_TEMPLATE:
      return {
        ...state,
        initialized_1_5_lib_cnc_s4_template: true
      };
    case actionTypes.INITIALIZED_LIB_DOCUMENT:
      return {
        ...state,
        initialized_1_6_lib_document: true
      };
    case actionTypes.INITIALIZED_LIB_CPARAMS:
      return {
        ...state,
        initialized_1_7_lib_cparams: true
      };

    case 'GLOBAL_FRESHNESS_UPDATE':
      return {
        ...state,
        global_freshness: (state.global_freshness + 1)
      };
    case actionTypes.ROUTE_SET:
      let routeData = routeDataGet(action.payload);
      if (routeData.second_screen === true) {
        if (state.secondScreen.opened === false) {
          // CASE second screen opening now
          return {
            ...state,
            routeSimple: {
              ...routeData,
              freshness: counter.getFreshInteger()
            },
            secondScreen: {
              opened: true,
              back_to_route: state.routeSimple.route
            }
          };
        } else {
          // CASE second screen already opened
          return {
            ...state,
            routeSimple: {
              ...routeData,
              freshness: counter.getFreshInteger()
            }
          };
        }
      } else {
        // CASE regular screen
        return {
          ...state,
          routeSimple: {
            ...routeData,
            freshness: counter.getFreshInteger()
          },
          secondScreen: {
            opened: false,
            back_to_route: action.payload
          }
        };
      }
    /*
    return {
      ...state,
      routeSimple: {
        ...routeData,
        freshness: counter.getFreshInteger()
      }
    };
    */

    case actionTypes.ROUTE_WITH_PARAMS_SET:
      let routeData2 = routeDataGet(action.payload.route);
      if (routeData2.second_screen === true) {
        if (state.secondScreen.opened === false) {
          // CASE second screen opening now
          return {
            ...state,
            routeSimple: {
              ...routeData2,
              route_params: action.payload.route_params,
              freshness: counter.getFreshInteger()
            },
            secondScreen: {
              opened: true,
              back_to_route: state.routeSimple.route
            }
          };
        } else {
          // CASE second screen already opened
          return {
            ...state,
            routeSimple: {
              ...routeData2,
              route_params: action.payload.route_params,
              freshness: counter.getFreshInteger()
            }
          };
        }
      } else {
        // CASE regular screen
        return {
          ...state,
          routeSimple: {
            ...routeData2,
            route_params: action.payload.route_params,
            freshness: counter.getFreshInteger()
          },
          secondScreen: {
            opened: false,
            back_to_route: action.payload.route
          }
        };
      }
    /*
    return {
      ...state,
      routeSimple: {
        ...routeData2,
        route_params: action.payload.route_params,
        freshness: counter.getFreshInteger()
      }
    };
    */

    case actionTypes.ROUTE_REFRESH:
      return {
        ...state,
        routeSimple: {
          ...state.routeSimple,
          freshness: counter.getFreshInteger()
        }
      };

    case actionTypes.ROUTE_SECOND_SCREEN_CLOSE:
      let routeData3 = routeDataGet(state.secondScreen.back_to_route);
      return {
        ...state,
        secondScreen: {
          ...state.secondScreen,
          opened: false
        },
        routeSimple: {
          ...routeData3,
          freshness: counter.getFreshInteger()
        }
      };

    case actionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        user: {
          ulogovan: false,
          role: "GUEST"
        }
        /*
        ulogovan: false,
        role: 'GUEST',
        username: ''
        */
      };

    case actionTypes.AUTH_FORMLOGIN_FETCHING:
      return {
        ...state,
        authLoginFetching: true
      };

    case actionTypes.AUTH_AUTOLOGIN_FETCHING:
      return {
        ...state,
        initial_autologin_completed: true
      };

    case actionTypes.AUTH_AUTOLOGIN_FAIL:
      return {
        ...state,
        authLoginFetching: false,
        user: {
          ...state.user,
          ulogovan: false,
          role: action.payload.role,
          username: ''
        }
      };

    case actionTypes.AUTH_AUTOLOGIN_SUCCESS:
      return {
        ...state,
        authLoginFetching: false,
        user: {
          ...state.user,
          ...action.payload.user,
          ulogovan: true,
        },
        serverInfo: action.payload.server_info.thisis
      }


    case actionTypes.SPINNER_GLOBAL_SHOW:
      return {
        ...state,
        spinnerGlobal: true
      };
    case actionTypes.SPINNER_GLOBAL_HIDE:
      return {
        ...state,
        spinnerGlobal: false
      };

    case actionTypes.SHOW_TOAST:
      return {
        ...state,
        obavestenja: [...state.obavestenja, action.payload]
      };
    case actionTypes.ANIMATED_CLOSING_TOAST:
      let newToasts = state.obavestenja.map((toast) => {
        if (toast.id === action.payload) {
          return {
            ...toast,
            toastClosing: true
          }
        }
        return toast;
      });
      return {
        ...state,
        obavestenja: newToasts
      };
    case actionTypes.CLOSE_TOAST:
      let newToasts2 = state.obavestenja.map((toast) => {
        if (toast.id === action.payload) {
          // ne brisemo nego flagujemo onaj koji necemo da prikazujemo vise
          return {
            ...toast,
            closed: true
          };
        }
        return toast;
      });
      return {
        ...state,
        obavestenja: newToasts2
      };

    case actionTypes.OBAVESTENJA_SUPERVALIDATOR:
      let newToasts3 = [...state.obavestenja];
      if (Array.isArray(action.payload)) {
        action.payload.forEach(error => {
          // stavka iz supervalidators errors array-a
          console.log(error);
          newToasts3.push({
            id: counter.getFreshInteger(),
            notificationType: tclocal.ERROR,
            title: error.errorName,
            description: null,
            toastClosing: false,
            closed: true
          });
        });
      }
      return {
        ...state,
        obavestenja: newToasts3
      };

    case actionTypes.SHOW_MODAL:
      let without_x_button = false;
      if (action.payload.options && action.payload.options.without_x_button === true) {
        without_x_button = true;
      }
      return {
        ...state,
        modal: {
          modalContent: action.payload.content,
          without_x_button: without_x_button,
          animateOut: false
        }
      };

    case actionTypes.ANIMATED_CLOSE_MODAL:
      return {
        ...state,
        modal: {
          ...state.modal,
          animateOut: true
        }
      };

    case actionTypes.CLOSE_MODAL:
      return {
        ...state,
        modal: {
          modalContent: false,
          animateOut: false
        }
      }


    /*
  case actionTypes.GENERAL_DATA_SUCCESS:
    return {
      ...state,
      opstiPodaci: {
        fetching: false
      },
      nn: {
        ...state.nn,
        data: action.payload.nn
      },
      kategorije: {
        ...state.kategorije,
        data: action.payload.kategorije
      }
    };
    */

    case actionTypes.GENERAL_DATA_CATCH:
      return {
        ...state,
        opstiPodaci: {
          fetching: false
        }
      };

    case 'CLICKED_ON_KOMORA_WIDGET':
      return {
        ...state,
        clickedKomoraSubkey: action.payload
      };

    case 'CLICKED_ON_MODUL_WIDGET':
      return {
        ...state,
        clickedModulSubkey: action.payload
      };

    case 'REMOVE_CLICKED_MODULE':
      return {
        ...state,
        clickedModulSubkey: ''
      };

    case actionTypes.USER_LIST_FETCHING:
      return {
        ...state,
        userList: {
          ...state.userList,
          fetching: true
        }
      };

    case actionTypes.USER_LIST_SUCCESS:
      return {
        ...state,
        userList: {
          fetching: false,
          data: action.payload
        },
        initialized_1_1_users_cache: true
      };

    case actionTypes.USER_LIST_FAIL:
      return {
        ...state,
        userList: {
          fetching: false,
          data: []
        }
      };

    case actionTypes.COMORDER_LOAD:
      return {
        ...state,
        comorderCurrent: action.payload,
        comorditemCurrent: false,
      };
    case actionTypes.COMORDER_UNLOAD:
      return {
        ...state,
        comorderCurrent: false,
        comorditemCurrent: false,
      };
    case actionTypes.COMORDER_LIST_FETCHING:
      return {
        ...state,
        comorderList: {
          ...state.comorderList,
          fetching: true
        }
      };
    case actionTypes.COMORDER_LIST_SUCCESS:
      return {
        ...state,
        comorderList: {
          fetching: false,
          data: action.payload
        }
      };
    case actionTypes.COMORDER_LIST_FAIL:
      return {
        ...state,
        comorderList: {
          fetching: false,
          data: []
        }
      };

    case actionTypes.COMORDITEM_LOAD:
      return {
        ...state,
        comorditemCurrent: action.payload
      };
    case actionTypes.COMORDITEM_UNLOAD:
      return {
        ...state,
        comorditemCurrent: false
      };
    case actionTypes.COMORDITEM_LIST_FETCHING:
      return {
        ...state,
        comorditemList: {
          ...state.comorditemList,
          fetching: true
        }
      };
    case actionTypes.COMORDITEM_LIST_SUCCESS:
      return {
        ...state,
        comorditemList: {
          fetching: false,
          data: action.payload
        }
      };
    case actionTypes.COMORDITEM_LIST_FAIL:
      return {
        ...state,
        comorditemList: {
          fetching: false,
          data: []
        }
      };
    case actionTypes.COMORDITEM_CREATE_SUCCESS:
      let created_entity_id = false;
      if (action.payload && action.payload.id) {
        created_entity_id = action.payload.id;
      }
      return {
        ...state,
        comorditemCreatedEntityId: created_entity_id
      }; // ovaj se verovatno nece koristiti


    case actionTypes.EXTERNAL_FILES_LIST_FETCHING:
      return {
        ...state,
        externalFiles: {
          ...state.externalFiles,
          fetching: true
        }
      };

    case actionTypes.EXTERNAL_FILES_LIST_SUCCESS:
      return {
        ...state,
        externalFiles: {
          fetching: false,
          data: action.payload
        }
      };

    case actionTypes.EXTERNAL_FILES_LIST_FAIL:
      return {
        ...state,
        externalFiles: {
          fetching: false,
          data: {}
        }
      }


    case actionTypes.GENUS_PP_LIST_FETCHING:
      return {
        ...state,
        ppGenusList: {
          ...state.ppGenusList,
          fetching: true
        }
      };

    case actionTypes.GENUS_PP_LIST_SUCCESS:
      return {
        ...state,
        ppGenusList: {
          fetching: false,
          data: action.payload
        }
      };

    case actionTypes.GENUS_PP_LIST_FAIL:
      return {
        ...state,
        ppGenusList: {
          fetching: false,
          data: []
        }
      };

    case actionTypes.ADMIN_SIMDB_GET_WHOLE_FETCHING:
      return {
        ...state,
        _dev_db_whole: null
      };

    case actionTypes.ADMIN_SIMDB_GET_WHOLE_FETCHED:
      return {
        ...state,
        _dev_db_whole: action.payload.payload
      };



    case 'CB_INBOX_FRESHNESS':
      return {
        ...state,
        cb_inbox_freshness: action.payload
      };

    case 'Z3D_MODAL_CLOSE':
      return {
        ...state,
        z3d: {
          modal_opened: false,
          cb_key: null
        }
      };

    case 'Z3D_MODAL_OPEN':
      return {
        ...state,
        z3d: {
          modal_opened: true,
          cb_key: action.payload
        }
      };

    case 'CHEATS_ENABLE':
      return {
        ...state,
        cheats: {
          enabled: true,
        }
      };


    default:
      return state;
  }

};


// COMBINE REDUCERS
const rootReducer = combineReducers({
  app: appReducer,
  draft: draftReducer
});

export default rootReducer;